import { createContext, useContext, Dispatch } from 'react';
import { hqvInitialState, hqvInitialStateType, HQV_ACTIONS } from '../../reducers/HQV';
import { propertySessionDataType } from '../SessionUpdateContext/index.types';

export interface HQVContextType {
  hqvState: hqvInitialStateType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hqvDispatch: Dispatch<{ type: HQV_ACTIONS; payload: any }>;
  // Optional setter methods - available when using Zustand store
  setPropertySessionData?: (sessionData: propertySessionDataType) => void;
  setPropertyID?: (propertyID: string) => void;
  setModalOpenState?: (isOpen: boolean) => void;
  setPropertyDistance?: (distance: string) => void;
}

export const HQVContext = createContext<HQVContextType>({
  hqvState: hqvInitialState,
  hqvDispatch: () => {
    // Default no-op dispatch
  },
});

export const useHQVContext = () => {
  return useContext(HQVContext);
};
